import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CreateGoal from "../components/CreateGoal";
import SkillGoal from "../components/SkillGoal";

const Goalpage = () => {
  const [goalType, setGoalType] = useState("test"); // "test" or "skill"
  const [isNavigating, setIsNavigating] = useState(false);
  const navigate = useNavigate();

  const navigateBackToOrigin = useCallback(() => {
    const historyObj =
      typeof window !== "undefined" ? window.history : undefined;
    const hasHistory =
      typeof historyObj?.state?.idx === "number"
        ? historyObj.state.idx > 0
        : (historyObj?.length || 0) > 1;

    if (hasHistory) {
      navigate(-1);
      return;
    }

    navigate("/practice/mygoals", { replace: true });
  }, [navigate]);

  const handleGoalCreated = () => {
    // Show loader and navigate back to parent MyGoals route after successful goal creation
    setIsNavigating(true);
    setTimeout(() => {
      navigateBackToOrigin();
    }, 500); // Small delay to show the loader
  };

  return (
    <div className="fixed inset-0 bg-white z-50 overflow-auto">
      {/* Header with back button */}
      <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-4">
        <button
          onClick={navigateBackToOrigin}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span className="text-sm font-medium">Back to My Goals</span>
        </button>
      </div>

      {/* Loading Overlay */}
      {isNavigating && (
        <div className="fixed inset-0 bg-white bg-opacity-90 z-60 flex items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0D99FF]"></div>
            <p className="text-gray-600 font-medium">Saving your goal...</p>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="p-4 sm:p-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-6 gap-4 sm:gap-6">
          <div className="bg-[#0D99FF] rounded-full p-3">
            <div className="bg-white rounded-full p-1">
              <div className="bg-[#0D99FF] rounded-full w-8 h-8 flex items-center justify-center">
                <span className="text-white text-xs sm:text-base">🎯</span>
              </div>
            </div>
          </div>
          <div className="text-center sm:text-left">
            <h2 className="text-gray-700 text-lg font-medium">
              Create New Goal
            </h2>
            <p className="text-gray-500 text-sm">
              What would you like to achieve?
            </p>
          </div>
        </div>

        {/* Goal Type Toggle */}
        <div className="mb-6">
          <p className="text-gray-600 mb-2">Goal Type</p>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 gap-2">
            <button
              onClick={() => setGoalType("test")}
              className={`py-2 px-8 rounded-full flex-1 ${
                goalType === "test"
                  ? "bg-[#0D99FF] text-white"
                  : "bg-white text-gray-600 border"
              }`}
            >
              Upcoming Test
            </button>
            <button
              onClick={() => setGoalType("skill")}
              className={`py-2 px-8 rounded-full flex-1 ${
                goalType === "skill"
                  ? "bg-[#0D99FF] text-white"
                  : "bg-white text-gray-600 border"
              }`}
            >
              Aanya recommended
            </button>
          </div>
          {goalType === "test" ? (
            <CreateGoal onGoalCreated={handleGoalCreated} />
          ) : (
            <SkillGoal onGoalCreated={handleGoalCreated} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Goalpage;
